export const TagSelectButton = ({
  text,
  type,
  onClick,
  handleKeyPress,
  classToChild,
}: {
  text: string;
  type: string;
  onClick(): void;
  handleKeyPress(event: any): void;
  classToChild?: string;
}): JSX.Element => {
  return (
    <div
      onClick={onClick}
      className={`${classToChild} hover:bg-blue100 p-4 cursor-pointer border-b border-grey75 flex justify-between outline-none focus:bg-blue100`}
      tabIndex={0}
      onKeyPress={handleKeyPress}
    >
      <div>
        {text} ({type})
      </div>
      <div className="text-sm font-icb">
        {type !== 'Län' && type !== 'Kommun'
          ? 'OMRÅDE'
          : type.toLocaleUpperCase()}
      </div>
    </div>
  );
};
